import styled from '@emotion/styled'
import { ConnectButton } from '@rainbow-me/rainbowkit'

import Row from '@/components/Row'
import ThemeSwitch from '@/components/ThemeSwitch/ThemeSwitch'
import WanPrice from '@/components/wan-price'

export default function PageHeader() {
  return (
    <Header between={true}>
      <HeaderLeft gap={true}></HeaderLeft>
      <HeaderRight>
        <ThemeSwitch inSiderbar={false} />
        <WanPrice />
        <ConnectButton showBalance={false} />
      </HeaderRight>
    </Header>
  )
}

const Header = styled(Row)`
  padding: 0 3.2rem;
  z-index: 1;
  flex: 0 0 auto;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    margin-bottom: 0;
    padding: 0;
  }
`

const HeaderLeft = styled(Row)``
const HeaderRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.2rem;
`
